window.PageNavigation = (function () {

    const selectors = {
        slider: '.page-navigation__slider',
        sliderWrapper: '#page-navigation-slider-wrapper',
        btnLeft: '#page-navigation-arrow-left',
        btnRight: '#page-navigation-arrow-right'
    };

    let sliderWidth = $(selectors.slider).width();
    let sliderWrapperWidth = $(selectors.sliderWrapper).width();
    let sliderWrapperMargins = parseInt($(selectors.sliderWrapper).css('margin-left') + $(selectors.sliderWrapper).css('margin-right'));
    let scrollPosition = $(selectors.sliderWrapper).scrollLeft();
    let newScrollPosition = 0;
    let scrollableAreaWidth = 220;
    let windowResizeTimer;
   
    return {
        init: function () {            
            this.bindUI();
            this.appendBtn();
        },

        bindUI: function () {
            var self = this;

            $(window).on('resize', function () {
                if (windowResizeTimer) clearTimeout(windowResizeTimer);
                windowResizeTimer = setTimeout(function () {
                    self.appendBtn();
                }, 100);
            });

            $(selectors.btnLeft).click(function () {
                self.scrollLeft();
                $(selectors.btnRight).removeClass('m-disable');
            });

            $(selectors.btnRight).click(function () {
                self.scrollRight();
                $(selectors.btnLeft).removeClass('m-disable');
            }); 
        },

        scrollLeft: function () {
            scrollPosition = $(selectors.sliderWrapper).scrollLeft();
            newScrollPosition = scrollPosition - scrollableAreaWidth;

            $(selectors.sliderWrapper).animate({
                scrollLeft: newScrollPosition
            }, 600);

            if (newScrollPosition <= 0) {
                $(selectors.btnLeft).addClass('m-disable');
            }
        },

        scrollRight: function () {
            scrollPosition = $(selectors.sliderWrapper).scrollLeft();
            newScrollPosition = scrollPosition + scrollableAreaWidth;

            $(selectors.sliderWrapper).animate({
                scrollLeft: newScrollPosition
            }, 600);
            
            if (sliderWrapperWidth + newScrollPosition - sliderWrapperMargins >= sliderWidth) {
                $(selectors.btnRight).addClass('m-disable');
            }
        },

        appendBtn: function () {
            if (sliderWidth <= ($(selectors.sliderWrapper).outerWidth())) {
                $(selectors.btnLeft).addClass('m-disable');
                $(selectors.btnRight).addClass('m-disable');
            } else {
                $(selectors.btnRight).removeClass('m-disable');
            }
        }
    }

}());

$(function () {
    if (!globalAppSettings.isMobileDevice) {
        PageNavigation.init();
    }    
});